import { useMutation, useQueryClient } from "@tanstack/react-query";

import { renewSubscription } from "../api/subscriptionApi";

/**
 * Hook to renew an existing subscription
 * Automatically invalidates subscription status on success
 */
export const useRenewSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ billingInterval }) => renewSubscription(billingInterval),
    onSuccess: () => {
      // Invalidate subscription status to fetch fresh data
      queryClient.invalidateQueries({ queryKey: ["subscription", "status"] });
    },
  });
};
